import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import bee from "../../Assets/Projects/Bee.png";
import shopping from "../../Assets/Projects/shopping home.png";
import booksy from "../../Assets/Projects/Book Shop.png";
import xwaiter from "../../Assets/Projects/xwaiter.png";
import puzzle from "../../Assets/Projects/nPuzzle.png";
import julia from "../../Assets/Projects/julia.png";

function Projects() {
  return (
    <Container id="projects" fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={xwaiter}
              isBlog={false}
              title="X Waiter"
              description="its my cutting-edge Restaurant and Cafe Management System, the ultimate solution to elevate your dining establishment's efficiency and customer experience. Our system seamlessly integrates with your operations, offering an array of features to simplify order management, enhance menu customization, and streamline your restaurant or cafe's daily tasks. Say goodbye to manual errors and hello to a smoother, more organized workflow. Experience the future of restaurant management with our state-of-the-art system."
              ghLink="https://github.com/abdallahMoussa/zad-xwaiter"
              demoLink="https://zad-xwaiter-git-main-abdallahmoussa.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={julia}
              isBlog={false}
              title="Julia Shopping"
              description="Introducing my online shopping project - a personal journey I started during the learning process. This project served as a valuable springboard in my education, allowing me to delve into the complexities of coding, web development, and user experience design.
              With this endeavor, I aimed to create a fully functional online shopping platform from scratch. It was an opportunity for me to test my programming skills, explore react js state mangment concepts."
              ghLink="https://github.com/abdallahMoussa/Julia-Shopping"
              demoLink="https://julia-shopping.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={booksy}
              isBlog={false}
              title="Booksy"
              description="Introducing my Online Bookstore Project - a personal journey I embarked on during my learning process. This project served as an invaluable stepping stone in my education, providing me with the opportunity to dive deep into the world of web development and user experience design.

              With this project, my primary goal was to construct a fully operational online bookstore from the ground up. It became a canvas for me to paint with code, test my programming skills, and explore the intricacies of state management in React.js."
              ghLink="https://github.com/abdallahMoussa/Online-Book-Shop"
              demoLink="https://online-book-shop.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bee}
              isBlog={false}
              title="Animated Bee"
              description="Welcome to a fascinating journey into the world of web development creativity! Have you ever wondered if you could bring a buzzing bee to life on a webpage, using nothing but HTML, CSS, and jQuery, without relying on any images or SVGs? Well, that's exactly what i`m about to do.

              In this showcase, i'll delve into the exciting realm of web animations and interactivity, where code becomes the brush and canvas for our digital masterpiece. Prepare to be amazed as we unveil a lifelike, animated bee that flits and buzzes across the screen, all thanks to the magic of web technologies."
              ghLink="https://github.com/abdallahMoussa/Animated-Wonderful-Bee"
              demoLink="https://animated-flying-bee.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={puzzle}
              isBlog={false}
              title="F-Dhrk"
              description="Many individuals often desire to play, visit coffee shops, or attend weddings, but they may not have friends available to join them in these activities. This is where F-Dhrk comes in - a platform where you can connect with like-minded people who share the same interests as you. Whether it's playing sports, grabbing a cup of coffee, or celebrating special occasions, you'll find a community of individuals who are eager to join you in these experiences."
              ghLink="https://github.com/abdallahMoussa/f-dhrk"
              demoLink="https://f-dhrk.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shopping}
              isBlog={false}
              title="Home Shopping"
              description="Introducing my online shopping project - a personal journey I started during the learning process. This project served as a valuable springboard in my education, allowing me to delve into the complexities of coding, web development, and user experience design.
              With this endeavor, I aimed to create a fully functional online shopping platform from scratch. It was an opportunity for me to test my programming skills, explore react js state mangment concepts."
              ghLink="https://github.com/abdallahMoussa/Online-Clothes-Shop"
              demoLink="https://online-clothes-shop.vercel.app/"
            />
          </Col>
        </Row>
        <div className="flex text-white">
          More Projects On{" "}
          <a href="https://github.com/abdallahMoussa" className="">
            GitHub
          </a>
        </div>
      </Container>
    </Container>
  );
}

export default Projects;
